export default data => (Object.keys(data).length
  ? `?${Object.keys(data).map(el => data[el] && `${el}=${encodeURI(data[el])}`).join('&')}`
  : '');
